import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";

import { CoreSidebarModule } from "@core/components";
import { CoreCommonModule } from "@core/common.module";
import { TranslateModule } from "@ngx-translate/core";
import { UtilsService } from "../../auth/service/utils.service";

import { locale as chatIt } from "./i18n/chatIt";
import { ContentHeaderModule } from "app/layout/components/content-header/content-header.module";
import chatRoutes from "./chat.routes";
import chatMenu from "./chat.menu";
import { ChatUserSidebarComponent } from "./components/chat-sidebars/chat-user-sidebar/chat-user-sidebar.component";
import { ChatComponent } from "./pages/chat/chat.component";
import { ChatContentComponent } from "./components/chat-content/chat-content.component";
import { ChatSidebarComponent } from "./components/chat-sidebars/chat-sidebar/chat-sidebar.component";
import { AuthenticationService } from "../../auth/service";

@NgModule({
  declarations: [ChatComponent, ChatContentComponent, ChatSidebarComponent, ChatUserSidebarComponent],
  imports: [CommonModule, ContentHeaderModule, RouterModule.forChild(chatRoutes), CoreSidebarModule, CoreCommonModule, TranslateModule, PerfectScrollbarModule, NgbModule],
  providers: []
})
export class ChatModule {
  constructor(private _utilService: UtilsService, private _auth: AuthenticationService) {
    if (this._auth.currentUserSubject.value?.type === "Dipendente") {
      this._utilService.initModule("chat", chatIt, chatMenu, []);
    }
  }
}
